import { Directive, OnInit, ElementRef, inject, input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { environment } from '../environments/environment';
import { Owner } from '../models/owner.model';
import { Router } from '@angular/router';

@Directive({
  selector: '[appPopulateForm]',
  standalone: true
})
export class PopulateFormDirective implements OnInit {
  private readonly elementRef = inject(ElementRef);
  private readonly router = inject(Router);
  
  public readonly form = input.required<FormGroup>();
  public readonly formType = input.required<string>();

  async ngOnInit() {
    // Only show test buttons if we're in development mode, not in production,
    // have mock data configured, and the URL contains "/test"
    if (environment.showPopulateButtons && 
        !environment.production && 
        environment.mockData && 
        (this.router.url.includes('/test') || this.router.url.includes('/test/'))) {
      const mockConfig = environment.mockData[this.formType()];
      if (mockConfig) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'mat-stroked-button populate-button';
        button.style.marginBottom = '1rem';
        button.innerHTML = `<span class="material-icons" style="vertical-align: middle; margin-right: 4px;">build_circle</span> Load Test Data`;
        
        button.addEventListener('click', async () => {
          try {
            const module = await import(`../shared/mock/${mockConfig}`);
            // If mockConfig is an array, show a select with every option
            if (Array.isArray(module.default)) {
              const select = document.createElement('select');
              select.className = 'mat-select';
              module.default.forEach((option: Owner) => {
                const opt = document.createElement('option');
                opt.value = option.firstName;
                opt.innerHTML = option.firstName;
                select.appendChild(opt);
              });
              select.addEventListener('change', () => {
                this.form().patchValue(module.default.find((o: Owner) => o.firstName === select.value));
              });
              button.replaceWith(select);
              this.form().patchValue(module.default[0]);
            } else {
              // If mockConfig is a single object, load it directly
              this.form().patchValue(module.default);
            }
          } catch (error) {
            console.error('Error loading mock data:', error);
          }
        });

        const formElement = this.elementRef.nativeElement;
        formElement.insertBefore(button, formElement.firstChild); 
      }
    }
  }
}